import { render, staticRenderFns } from "./MerchantDetail.vue?vue&type=template&id=9afefd58&"
import script from "./MerchantDetail.vue?vue&type=script&lang=js&"
export * from "./MerchantDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports